<template>
  <div class="offlineTraining">
    <div class="statusBar"></div>

    <div class="offlineContent">
      <div class="open_app video_app d-f jc-sb ai-c">
        <img src="../../assets/images/detail/logo.png" alt="" />
        <span class="content_app">打开文化广东APP，查看详情内容</span>
        <div class="open_btn" @click="openApp">立即打开</div>
      </div>
      <div class="swiper">
        <!-- <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" /> -->
        <van-swipe @change="onChange">
          <van-swipe-item> <img :src="detailInfo.picUrl" alt="" class="swiper_img" /> </van-swipe-item>
          <!-- <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/5</div>
        </template> -->
        </van-swipe>
      </div>
      <div class="count_down d-f jc-sb ai-c" :class="detailInfo.status == 1 ? 'disabled' : ''" v-if="detailInfo.status !== 3">
        <img src="@/assets/images/detail/performance/count_bg.png" alt="" class="count_bg" v-if="detailInfo.status == 2" />
        <img src="@/assets/images/detail/performance/count_bg_.png" alt="" class="count_bg" v-if="detailInfo.status == 1" />

        <div class="status">{{ signStatus[detailInfo.status - 1] }}</div>
        <div class="time" :class="detailInfo.status == 1 ? 'disabled' : ''">
          {{ detailInfo.status == 2 ? '距报名结束' : '距报名开始' }}： <span>{{ hours }}</span
          >小时<span>{{ minutes }}</span
          >分<span>{{ seconds }}</span
          >秒
        </div>
      </div>

      <div class="introduction">
        <div class="d-f jc-sb ai-c">
          <span class="title">{{ detailInfo.name }}</span>
          <!-- <div class="d-f ai-c view_total"><img src="@/assets/images/detail/culturalCollection/view.png" alt="" class="icon" /> <span>123</span></div> -->
        </div>

        <div class="tags d-f jc-sb ai-c">
          <div class="d-f ai-c">
            <div class="tag_item">{{ detailInfo.artTypeName }}</div>
            <div class="tag_item">{{ detailInfo.trainTypeName }}</div>
          </div>
          <!-- <div class="total">{{ detailInfo.regNumber }}/{{ detailInfo.maxNumber }}人</div> -->
        </div>

        <div class="card_info d-f fxd-c">
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/performance/baom.png" alt="" />
            <div>报名人数：{{ detailInfo.regNumber }}/{{ detailInfo.maxNumber }}人</div>
          </div>
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/performance/date.png" alt="" />
            <div>上课时间：{{ detailInfo.startDay }} - {{ detailInfo.endDay }}</div>
          </div>
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/performance/date.png" alt="" />
            <div>报名时间：{{ detailInfo.regStartDay }} - {{ detailInfo.regEndDay }}</div>
          </div>
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/address.png" alt="" />
            <div>
              上课地点：{{ detailInfo.address }} |
              <span style="color: #a97048"> {{ detailInfo.distance | setMorKm }}km</span>
            </div>
            <img src="@/assets/images/detail/performance/navigation.png" alt="" class="icon" />
          </div>
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/performance/address.png" alt="" />
            <div>主办单位：{{ detailInfo.publishUnitName }}</div>
          </div>
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/performance/age.png" alt="" />

            <div>
              年龄要求：<span v-if="detailInfo.limitAge == 0">全年龄</span><span v-else>{{ detailInfo.minAge }}岁～{{ detailInfo.maxAge }}岁</span>
            </div>
          </div>
          <div class="info_item d-f ai-c">
            <img src="@/assets/images/detail/performance/speaker.png" alt="" />
            <div>授课老师：{{ detailInfo.personName }}</div>
          </div>
        </div>
      </div>
      <div class="detail_tabs" v-if="detailInfo.detail">
        <div>
          <div class="tab_item">课程简介</div>
        </div>
        <div class="content">
          <div class="detail_msg" v-html="detailInfo.detail">
            <!-- {{ detailInfo.detail }} -->
          </div>
        </div>
      </div>

      <div class="class_schedule" v-if="detailInfo.classList.length > 0">
        <div class="d-f jc-sb ai-c">
          <div class="title">课程表</div>
          <div class="total">共{{ detailInfo.classList.length }}节</div>
        </div>
        <div class="class_list">
          <div class="class_item" v-for="item in detailInfo.classList">
            <img src="@/assets/images/detail/performance/img_tsg_bg.png" alt="" class="bg" />
            <div>{{ item.classDate }} {{ item.classStartTime }}-{{ item.classEndTime }}</div>
          </div>
        </div>
      </div>

      <div class="handle_button d-f jc-sb ai-c">
        <div class="handle_item d-f ai-c border_right" @click="openApp">
          <img src="@/assets/images/detail/performance/circle_share.png" alt="" class="icon_handle" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
        <!-- <div>报名人数：{{ detailInfo.regNumber }}/{{ detailInfo.maxNumber }}人</div> -->
        <div class="btn disabled" v-if="detailInfo.regStatus == 1">{{ '已报名' }}</div>

        <div class="btn disabled" v-else-if="detailInfo.regNumber == detailInfo.maxNumber">{{ '名额已满' }}</div>
        <div class="btn" v-else :class="detailInfo.status == 2 ? '' : 'disabled'" @click="openApp">{{ detailInfo.status == 3 ? '报名已结束' : '立即报名' }}</div>
      </div>
    </div>
    <van-dialog
      v-model="dialogShow"
      title="请先下载客户端"
      show-cancel-button
      confirmButtonText="立即下载"
      confirmButtonColor="#A97048"
      cancelButtonText="我知道了"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
    >
      <div class="content_dialog">下载APP后查看完整内容</div>
    </van-dialog>
    <!-- <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" /> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { offlineDetail } from '@/api/cultivate'

export default {
  name: 'offlineTraining',
  data() {
    return {
      current: 0,
      showShare: false,
      tabs: ['详情介绍', '展览展示'],
      tabIndex: 0,
      detailInfo: {},
      signStatus: ['即将开始', '报名中', '已结束'],
      targetTime: '',
      hours: '',
      minutes: '',
      seconds: '',
      timer: null,
      id: '',
      dialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  methods: {
    // UNInavigation() {
    //   this.$myUni.postMessage({
    //     data: {
    //       methodsName: 'UNInavigation',
    //       data: {
    //         name: this.detailInfo.address,
    //         latitude: this.detailInfo.latitude,
    //         longitude: this.detailInfo.longitude,
    //       },
    //     },
    //   })
    // },
    // back() {
    //   this.$myUni.navigateBack({
    //     delta: 1,
    //   })
    // },
    openApp() {
      this.dialogShow = true
    },
    dialogCancel() {},
    dialogConfirm() {
      window.location.href = 'https://www.pgyer.com/ghjCEr'
    },
    onChange(index) {
      this.current = index
    },

    getDetail() {
      offlineDetail({ id: this.id, longitude: '', latitude: '' }).then((res) => {
        console.log(res)
        this.detailInfo = res.result
        // this.detailInfo.status = 3
        if (this.detailInfo.status == 1) {
          this.targetTime = new Date(this.detailInfo.regStartDay).getTime()
        } else if (this.detailInfo.status == 2) {
          this.targetTime = new Date(this.detailInfo.regEndDay).getTime()
        }
      })
    },
    // signUp() {
    //   if (this.detailInfo.status !== 2) {
    //     return
    //   }
    //   this.$router.push({
    //     path: '/detail/activityRegistration',
    //     query: {
    //       id: this.detailInfo.id,
    //       name: this.detailInfo.name,
    //       type: 'offlineTraining',
    //     },
    //   })
    // },
    startCountdown() {
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        const now = new Date().getTime()
        const distance = this.targetTime - now

        // 计算剩余时间并格式化为时分秒
        this.hours = Math.floor(distance / (1000 * 60 * 60))
        this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        this.seconds = Math.floor((distance % (1000 * 60)) / 1000)

        // 将单个数字转换为两位数的字符串格式
        this.hours = this.formatNumber(this.hours)
        this.minutes = this.formatNumber(this.minutes)
        this.seconds = this.formatNumber(this.seconds)
      }, 1000)
    },
    formatNumber(num) {
      return num < 10 ? `0${num}` : `${num}`
    },
  },
  mounted() {
    console.log('this.$route=============>', this.$route.query)
    const { id } = this.$route.query
    this.id = id
    // const data = JSON.parse(this.$route.query.params)
    // const { id, longitude, latitude } = data
    // const params = { id, longitude, latitude }
    this.getDetail()
    this.startCountdown()
  },
  // 退出页面清除定时器
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>
<style lang="scss">
.offlineTraining {
  width: 100%;
  height: 100vh;
  background: #fff;
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #fff;
  }
  .content_dialog {
    padding: 1.6rem;
    font-size: 0.7rem;
    color: #212121;
    line-height: 1rem;
    .rules {
      font-weight: 600;
      color: #a97048;
    }
  }
  .offlineContent {
    width: 100%;
    // height: calc(100% - 40px - env(safe-area-inset-top));
    height: calc(100% - 40px);
    position: absolute;
    // top: calc(40px + env(safe-area-inset-top));
    top: 40px;
    left: 0;
    overflow-y: auto;
  }
  .tags {
    margin: 0.4rem 0 0.65rem 0;
  }

  .tag_item {
    font-size: 0.6rem;
    padding: 0 0.3rem;
    // color: #47988aff;
    color: #a97048;
    height: 0.9rem;
    line-height: 0.9rem;
    // background: #bedada;
    background: #f9eddc;

    border-radius: 2px;
    margin-right: 0.4rem;
    // margin-top: 0.4rem;
  }
  .total {
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.8rem;
  }

  // .collect_button {
  //   padding-top: 0.6rem;
  //   padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
  //   background: #fff;
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 2.4rem;
  //   .collect {
  //     font-size: 0.7rem;
  //     font-weight: 400;
  //     color: #212121;
  //     img {
  //       width: 1.4rem;
  //       height: 1.4rem;
  //       margin-right: 8px;
  //     }
  //   }
  // }

  .handle_button {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 2.9rem;
    width: 100%;
    background: #fff;
    padding: 0 0.6rem 0 0.6rem;
    font-size: 0.7rem;
    // color: #47988a;
    color: #a97048;
    line-height: 1rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .handle_item {
      &.border_right {
        // padding-right: 0.6rem;
        // position: relative;
        // ::after {
        //   position: absolute;
        //   content: '';
        //   display: inline-block;
        //   width: 1px;
        //   height: 0.7rem;
        //   top: 0.35rem;
        //   right: 0;
        //   background: #47988a;
        // }
      }
      &.border_left {
        padding-left: 0.6rem;
      }
      .icon_handle {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 0.2rem;
      }
    }
    .btn,
    .disabled {
      width: 13.3rem;
      text-align: center;
      height: 1.8rem;
      line-height: 1.8rem;
      // background: #47988a;
      background: #a97048;
      border-radius: 0.9rem;
      font-size: 0.7rem;
      color: #ffffff;
    }
    .disabled {
      color: #ffffff;
      background: #cccccc;
    }
  }

  .card_info {
    // margin-top: 0.8rem;
    // padding-bottom: 0.8rem;
    // border-bottom: 1px solid #f4f4f4;
    .info_item {
      height: 1.2rem;
      line-height: 1.2rem;
      // margin-bottom: 0.2rem;
      img {
        width: 0.7rem;
        height: 0.7rem;
        margin-right: 0.2rem;
      }
      .icon {
        margin-left: 1.2rem;
        width: 1.2rem;
        height: 1.2rem;
      }
      div {
        color: #666666;
        line-height: 16px;
        font-size: 0.6rem;
      }
    }
  }
  .swiper {
    width: 100%;
    height: 12.5rem;
    .back {
      z-index: 10;
      position: fixed;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 48px;
      // top: calc(40px + env(safe-area-inset-top));
    }

    .swiper_img {
      width: 100%;
      height: 12.5rem;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 8px;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .count_down {
    // padding: 0 1.35rem;
    position: relative;
    width: 100%;
    // height: 2.4rem;
    height: 2.2rem;
    background: linear-gradient(140deg, #ff4229 0%, #ff7541 100%);
    &.disabled {
      // background: linear-gradient(140deg, #47988a 0%, #47988a 100%);
      background: linear-gradient(180deg, #ffc39a 0%, #b57344 100%);
    }
    .count_bg {
      z-index: 1;
      position: absolute;
      right: 0;
      top: -4px;
      width: 12.75rem;
      height: 2.4rem;
    }
    .status {
      width: 40%;
      text-align: center;
      font-size: 0.8rem;
      color: #ffffff;
      line-height: 1.2rem;
    }
    .time,
    .disabled {
      z-index: 2;
      width: 60%;
      text-align: center;
      font-size: 0.6rem;
      color: #ff4e2f;
      line-height: 0.8rem;
      span {
        display: inline-block;
        width: 0.9rem;
        height: 0.9rem;
        line-height: 0.9rem;
        text-align: center;
        background: linear-gradient(138deg, #ff7044 0%, #ff5926 100%);
        border-radius: 2px;
        color: #fff;
        margin: 0 2px;
      }
    }
    .disabled {
      // color: #47988a;

      color: #a97048;
      span {
        background: linear-gradient(180deg, #ffc39a 0%, #b57344 100%);
        // background: linear-gradient(140deg, #47988a 0%, #47988a 100%);
      }
    }
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .detail_tabs {
    padding: 0.75rem 0.6rem 0 0.6rem;

    .tab_item {
      position: relative;
      font-size: 0.8rem;
      // color: #999999;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
      margin-right: 0.8rem;
      &.active {
        font-weight: 600;
        color: #212121;
        &::before {
          content: '';
          display: inline-block;
          width: 1.6rem;
          height: 2px;
          background: #47988a;
          border-radius: 2px;
          position: absolute;
          left: calc(50% - 0.8rem);
          bottom: -4px;
        }
      }
    }
    .content {
      margin-top: 0.9rem;
      .detail_msg {
        font-size: 0.7rem;
        color: #666666;
        line-height: 1rem;
      }
      .exhibition {
        .exhibition_item {
          img {
            width: 8.45rem;
            height: 8.45rem;
            border-radius: 0.5rem;
          }
          .title {
            font-size: 0.7rem;
            font-weight: 600;
            color: #212121;
            line-height: 1rem;
            margin: 0.4rem 0 0.6rem 0;
          }
        }
      }
    }
  }
  .class_schedule {
    padding: 1.2rem 0.6rem 0 0.6rem;
    padding-bottom: calc(2.5rem + env(safe-area-inset-bottom));

    .title {
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
    }
    .total {
      font-size: 0.7rem;
      // color: #47988a;
      color: #a97048;
      line-height: 1rem;
    }
    .class_list {
      margin-top: 0.6rem;
      .class_item {
        margin-bottom: 0.6rem;
        padding-left: 2.25rem;
        position: relative;
        width: 100%;
        height: 2.1rem;
        line-height: 2.1rem;
        // background: linear-gradient(90deg, #e1f5f2 0%, #cfeae6 100%);
        background: #f8e8d5;
        border-radius: 0.4rem;
        font-size: 0.7rem;
        font-weight: 600;
        // color: #47988a;
        color: #a97048;
        .bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 1.8rem;
          height: 2.1rem;
        }
      }
    }
  }
}
</style>
